var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1302,
    viewBox: "0 0 1440 1302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292 453L-23 579.977L292 707L607 579.977L292 453Z",
    fill: "#58AEBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M292 154L-23 280.977L292 408L607 280.977L292 154Z",
    fill: "#58AEBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M292 749L-23 875.977L292 1003L607 875.977L292 749Z",
    fill: "#58AEBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M292 1048L-23 1174.98L292 1302L607 1174.98L292 1048Z",
    fill: "#58AEBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M970 453L655 579.977L970 707L1285 579.977L970 453Z",
    fill: "#58AEBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M970 154L655 280.977L970 408L1285 280.977L970 154Z",
    fill: "#58AEBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M970 749L655 875.977L970 1003L1285 875.977L970 749Z",
    fill: "#58AEBB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M970 1048L655 1174.98L970 1302L1285 1174.98L970 1048Z",
    fill: "#58AEBB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M631 600L316 726.977L631 854L946 726.977L631 600Z",
    fill: "#58AEBB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M631 898L316 1024.98L631 1152L946 1024.98L631 898Z",
    fill: "#58AEBB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M631 300L316 426.977L631 554L946 426.977L631 300Z",
    fill: "#58AEBB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M631 0L316 126.977L631 254L946 126.977L631 0Z",
    fill: "#58AEBB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-46.9999 600L-362 726.977L-46.9999 854L268 726.977L-46.9999 600Z",
    fill: "#58AEBB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M-46.9999 898L-362 1024.98L-46.9999 1152L268 1024.98L-46.9999 898Z",
    fill: "#58AEBB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M-46.9999 300L-362 426.977L-46.9999 554L268 426.977L-46.9999 300Z",
    fill: "#58AEBB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M-46.9999 0L-362 126.977L-46.9999 254L268 126.977L-46.9999 0Z",
    fill: "#58AEBB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1309 602L994 728.977L1309 856L1624 728.977L1309 602Z",
    fill: "#58AEBB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1309 900L994 1026.98L1309 1154L1624 1026.98L1309 900Z",
    fill: "#58AEBB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1309 302L994 428.977L1309 556L1624 428.977L1309 302Z",
    fill: "#58AEBB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1309 2L994 128.977L1309 256L1624 128.977L1309 2Z",
    fill: "#58AEBB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1648 452L1333 578.977L1648 706L1963 578.977L1648 452Z",
    fill: "#58AEBB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1648 153L1333 279.977L1648 407L1963 279.977L1648 153Z",
    fill: "#58AEBB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1648 748L1333 874.977L1648 1002L1963 874.977L1648 748Z",
    fill: "#58AEBB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1648 1047L1333 1173.98L1648 1301L1963 1173.98L1648 1047Z",
    fill: "#58AEBB"
  })), /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 590,
    fill: "white",
    style: {
      color: "white",
      fontSize: 36,
      fontWeight: 800,
      fontFamily: "\"Roboto\", sans-serif"
    }
  }, "Functional Programming"), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 710,
    fill: "white",
    style: {
      color: "white",
      fontSize: 36,
      fontWeight: 800,
      fontFamily: "\"Roboto\", sans-serif"
    }
  }, "Backend System"), /*#__PURE__*/React.createElement("text", {
    x: 528,
    y: 760,
    fill: "white",
    style: {
      color: "white",
      fontSize: 36,
      fontWeight: 800,
      fontFamily: "\"Roboto\", sans-serif"
    }
  }, "for stabilizing"), /*#__PURE__*/React.createElement("text", {
    x: 865,
    y: 565,
    fill: "white",
    style: {
      color: "white",
      fontSize: 36,
      fontWeight: 800,
      fontFamily: "\"Roboto\", sans-serif"
    }
  }, "Programming"), /*#__PURE__*/React.createElement("text", {
    x: 850,
    y: 615,
    fill: "white",
    style: {
      color: "white",
      fontSize: 36,
      fontWeight: 800,
      fontFamily: "\"Roboto\", sans-serif"
    }
  }, "language design"), /*#__PURE__*/React.createElement("text", {
    x: 1220,
    y: 710,
    fill: "white",
    style: {
      color: "white",
      fontSize: 36,
      fontWeight: 800,
      fontFamily: "\"Roboto\", sans-serif"
    }
  }, "Blockchain"), /*#__PURE__*/React.createElement("text", {
    x: 1200,
    y: 760,
    fill: "white",
    style: {
      color: "white",
      fontSize: 36,
      fontWeight: 800,
      fontFamily: "\"Roboto\", sans-serif"
    }
  }, "development"));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.04b81f943d6f9cb4ceec3015d7b855b4.svg";
export { ForwardRef as ReactComponent };